/**
 * GTM + GA4 analytics utilities
 *
 * GTM container ID: set REACT_APP_GTM_ID in .env
 * GA4 is configured inside GTM (not hardcoded here)
 */

const GTM_ID = process.env.REACT_APP_GTM_ID;

/**
 * Initialize GTM with consent mode defaults (denied until user consents)
 * Called once in index.html via inline script, but this sets up the dataLayer
 */
export function initGTMConsent() {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  // Set consent defaults BEFORE GTM loads — everything denied
  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500,
  });

  // Restore consent from previous session
  const stored = localStorage.getItem('cookieConsent');
  if (stored === 'accepted') {
    updateConsent(true);
  }
}

/**
 * Update GTM consent state
 */
export function updateConsent(granted) {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  const state = granted ? 'granted' : 'denied';
  gtag('consent', 'update', {
    analytics_storage: state,
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
  });
}

/**
 * Push a custom event to the dataLayer
 */
export function trackEvent(eventName, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
}

/**
 * Track form submission conversion events
 */
export function trackFormSubmit(formType, extraData = {}) {
  trackEvent('form_submit', {
    form_type: formType,
    ...extraData,
  });
}

/**
 * Track virtual page views (for SPA route changes)
 */
export function trackPageView(path, title) {
  trackEvent('virtual_pageview', {
    page_path: path,
    page_title: title || document.title,
  });
}

/**
 * Get GTM container ID
 */
export function getGTMId() {
  return GTM_ID;
}
